import { Button } from "@mantine/core";
import React from "react";
import { HttpClientError } from "../../../providers/HttpClient";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import useAudienceCount from "../../../common/hooks/useAudienceCount";

type CreateSurveyButtonProps = {
  tagIds: number[];
  segmentIds?: number[];
  targetingType: "tags" | "segments";
  loading?: boolean;
  onClick?: () => void;
};

const CreateSurveyButton: React.FC<CreateSurveyButtonProps> = ({
  tagIds,
  segmentIds = [],
  targetingType,
  loading,
  onClick,
}) => {
  const { audienceCount, isLoadingCount, isError, error } = useAudienceCount(
    targetingType,
    tagIds,
    segmentIds
  );

  if (loading || isLoadingCount) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <div>{HttpClientError(error)}</div>;
  }

  return (
    <Button
      id="publishSurveyButton"
      name="publishSurveyButton"
      fullWidth
      radius="md"
      type="button"
      color="jem-theme"
      loaderPosition="right"
      disabled={!audienceCount || audienceCount === 0}
      onClick={onClick}
    >
      Send to {audienceCount} Employees
    </Button>
  );
};
export default CreateSurveyButton;
